import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import firebase from 'firebase/compat';
import { getToken, onMessage } from 'firebase/messaging';
import { Subject } from 'rxjs';

import { FIREBASE_API_URL, FIREBASE_CONFIG, FIREBASE_MESSAGING } from '../tokens/firebase.tokens';

import MessagePayload = firebase.messaging.MessagePayload;

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', event => {
    if (event.data && event.data.action === 'chat:message:received') {
      // Play the sound
      const notificationAudio = document.getElementById('notification-sound') as HTMLAudioElement;
      notificationAudio.muted = false;
      console.log('notifications started');
      notificationAudio.play().catch(error => {
        console.error('Audio playback failed:', error);
      });
    }
  });
}

@Injectable({ providedIn: 'root' })
export class FirebaseService {
  private readonly http = inject(HttpClient);
  private readonly messaging = inject(FIREBASE_MESSAGING);
  private readonly apiUrl = inject(FIREBASE_API_URL);
  private readonly firebaseConfig = inject(FIREBASE_CONFIG);

  private events$ = new Subject<MessagePayload>();

  requestNotificationsPermission() {
    Notification.requestPermission().then(permission => {
      if (permission === 'granted') {
        getToken(this.messaging, { vapidKey: this.firebaseConfig.vapidKey })
          .then(currentToken => {
            return currentToken
              ? this.http
                  .post(`${this.apiUrl}/notifications/tokens/register`, { pushToken: currentToken })
                  .subscribe(() => console.log('Notification token successfully registered'))
              : console.log('No registration token available. Request permission to generate one.');
          })
          .catch(err => console.error('An error occurred while retrieving token. ', err));
      } else console.log('Unable to get permission to notify.');
    });
  }

  listen() {
    onMessage(this.messaging, payload => this.events$.next(payload));
  }

  getEvents() {
    return this.events$.asObservable();
  }
}
